import { render, staticRenderFns } from "./detaliPageConRoomBf.vue?vue&type=template&id=4c0387b8&scoped=true"
import script from "./detaliPageConRoomBf.vue?vue&type=script&lang=js"
export * from "./detaliPageConRoomBf.vue?vue&type=script&lang=js"
import style0 from "./detaliPageConRoomBf.vue?vue&type=style&index=0&id=4c0387b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0387b8",
  null
  
)

export default component.exports